module.exports = __webpack_public_path__ + "media/St 4-thermostat2-incorrect.39911cc4.wav";